import { useState, useEffect } from "react"

import appletOrConnectionPath from "app/scripts/applet_or_connection_path"
import SmallAppletCard from "shared/components/applet_card/ifttt_next/small_applet_card"

import { fetchRecommendedAppletsV2 } from "./api"
import Header from "./header"
import Spinner from "shared/components/spinner"

import "./recommended_applets.scss"
import { Service } from "types"

interface Props {
  onClickBack: () => void
  onSkip: (location: string) => void
  progressBarSteps: Array<string>
  selectedService: Service | null
  userIsOnboarding: boolean
}

export interface Applet {
  id: string
  status: string
}

const RecommendedApplets = ({ onClickBack, onSkip, progressBarSteps, selectedService, userIsOnboarding }: Props) => {
  const [loading, setLoading] = useState(false)
  const [applets, setApplets] = useState<Applet[]>([])

  useEffect(() => {
    const serviceModuleName = selectedService?.connected ? selectedService.module_name : "none"

    const effect = async () => {
      setLoading(true)

      if (selectedService?.connected) {
        const url = new URL(location.href)
        url.searchParams.set("service", selectedService.module_name)
        history.replaceState(null, "", url) // maintains the selected service applets if user refreshes the page
      } else if (selectedService?.connected === false) {
        window.appendFlash(`Error connecting to ${selectedService.name}`, "danger")
      }

      const applets = await fetchRecommendedAppletsV2(serviceModuleName)

      setApplets(applets)
      setLoading(false)
    }

    effect()
  }, [])

  const subtitleCopy = "Click on any card to enable these useful automations."
  const titleCopy = userIsOnboarding ? "Connect your first Applet" : "Applets suggested for you"

  if (userIsOnboarding) {
    sessionStorage.setItem("userOnboardingBucket", "newUserIntake")
  }

  return (
    <>
      <Header
        onClickBack={onClickBack}
        onSkip={onSkip}
        page="applets"
        progressBarSteps={progressBarSteps}
        title={titleCopy}
      />
      <div styleName="container">
        {loading ? (
          <Spinner />
        ) : (
          <>
            <p className="txt-body-3">{subtitleCopy}</p>
            <ul className="web-applet-cards">
              {applets.map(applet => (
                <li className="my-web-applet-card web-applet-card" styleName="applet" key={applet.id}>
                  <SmallAppletCard
                    appletPath={appletOrConnectionPath(applet)}
                    applet={applet}
                    onAppletClick={() => {}}
                    showConnectButton={true}
                    isOnboardingApplet={true}
                    target="_blank"
                    rel="opener"
                  />
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </>
  )
}

export default RecommendedApplets
